var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"m-0 font-medium text-gray-900 ds-text-4xl"},[_vm._v(_vm._s(_vm.isBaseball ? _vm.baseballPositions : _vm.positions.join(', ')))])
}
var staticRenderFns = []

export { render, staticRenderFns }